export enum Currency {
  Pound = '£',
  Euro = '€',
  Dollar = '$',
}
